import { createTranslationRef } from '@backstage/core-plugin-api/alpha';

export const userMenuTranslationRef = createTranslationRef({
  id: 'app.userMenu',
  messages: {
    'button.ariaLabel': 'User menu',
    'menu.theme': 'Theme',
    'menu.theme.auto': 'Auto',
    'menu.language': 'Language',
    'menu.settings': 'Settings',
    'menu.logout': 'Log out',
  },
});

